import { FormBase } from 'core/components';

export default class InsuranceOrderingUploadForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'file',
                    label: 'INSURANCE_ORDERING.UPLOAD.FILE_LABEL',
                    placeholder: 'INSURANCE_ORDERING.UPLOAD.FILE_PLACEHOLDER',
                    type:'file'
                }
            ],
        };
    }
}
